import { Product } from '@@types'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import { useMediaQuery } from 'usehooks-ts'

import { useCartStore } from '@entities/Cart'

import useCartComment from '@features/cart/hooks/useCartComment'

import Button from '@shared/ui/button'

import styles from './styles.module.scss'



interface CommentButtonProps {
  product: Product;
}

export default function CommentButton (props: CommentButtonProps) {
  const { product } = props
  const { t: tca } = useTranslation('cart')
  const { t: tc } = useTranslation('common')
  const { hasComment } = useCartStore()
  const { openCartCommentModal } = useCartComment()

  const hasProductComment = useMemo(() => {
    return hasComment(product.id)
  }, [ product, hasComment ])

  const isMobile = useMediaQuery('(max-width: 375px)')

  if (hasProductComment) {
    return (
      <Button
        theme="grey"
        className={isMobile ? styles.editButton : styles.button}
        onClick={() => openCartCommentModal(product)}
      >
        {isMobile && (
          <ReactSVG
            src="/icons/pencil.svg"
            wrapper="span"
            className={styles.icon}
          />
        )}
        {isMobile ? tc('wish.edit_short') : tc('wish.edit_full')}
      </Button>
    )
  }

  return (
    <Button
      theme="grey"
      className={styles.button}
      onClick={() => openCartCommentModal(product)}
    >
      <ReactSVG
        src="/icons/pencil.svg"
        wrapper="span"
        className={styles.icon}
      />
      {tca('comment.add')}
    </Button>
  )
}